module.exports = __webpack_public_path__ + "img/_icon_plans.4f3e999f.svg";